import { render } from "./barLoader.vue?vue&type=template&id=4d15027a&scoped=true"
import script from "./barLoader.vue?vue&type=script&lang=js"
export * from "./barLoader.vue?vue&type=script&lang=js"

import "./barLoader.vue?vue&type=style&index=0&id=4d15027a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d15027a"]])

export default __exports__